import type { ConferenceTagSummary, ConferenceTagSummaryItem, ContentSummary, TagSummaryFeedback } from '../../types/conferences.tags.js';
import { safeJsonDateRequired } from './date.js';

export function transformContentSummary(data: ContentSummary<string>): ContentSummary | null {
  if (!data) return null;

  return {
    ...data,
    generatedOn: safeJsonDateRequired(data.generatedOn),
  };
}

export function transformConferenceTagSummaryItem(
  item: ConferenceTagSummaryItem<string>,
): ConferenceTagSummaryItem {
  const transformedSummary = transformTagSummary(item.summary);
  if (!transformedSummary) {
    throw new Error('Failed to transform tag summary');
  }

  return {
    ...item,
    summary: transformedSummary,
    children: item.children.map(transformConferenceTagSummaryItem),
  };
}

export function transformTagSummary(summary: ConferenceTagSummary<string> | null): ConferenceTagSummary | null {
  if (!summary) {
    return null;
  }

  return {
    ...summary,
    generatedOn: safeJsonDateRequired(summary.generatedOn),
  };
}

export function transformConferenceTagSummaryFeedback(
  item: TagSummaryFeedback<string>,
): TagSummaryFeedback {
  return {
    ...item,
    lastUpdatedOn: safeJsonDateRequired(item.lastUpdatedOn),
  };
}